import { Editor } from '@tiptap/core';
import EditorCache from '../editorcache';
import { serializer } from '../wikitext';

interface LegacyEditorHandle {
   legacy: true;
   value: string;
   text: string;
   el: any;
   editable: any;
}

const isLegacy = (editor: any): boolean => Boolean(editor?.legacy);

export const setEditor = (editorid: string, editor: Editor) => {
   EditorCache.set(editorid, editor);
};

export const getEditor = (editorid: string): Editor | null => {
   const editor = EditorCache.get(editorid);
   if (isLegacy(editor)) {
      return null;
   }
   return editor;
};

const getEditorOrLegacy = (editorid: string): Editor | LegacyEditorHandle =>
   EditorCache.get(editorid);

export const getSerializedText = (editorid: string): string => {
   const editor = getEditorOrLegacy(editorid);
   if (isLegacy(editor)) {
      return (editor as LegacyEditorHandle).text;
   }
   const doc = (editor as Editor)?.state?.doc;
   return doc ? serializer.serialize(doc) : '';
};

export const getText = (editorid: string): string => {
   const editor = getEditorOrLegacy(editorid);
   if (isLegacy(editor)) {
      return (editor as LegacyEditorHandle).text;
   }
   return (editor as Editor)?.getText();
};

export const focusEditor = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.focus();
};

export const clearContent = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.clearContent(false);
   editor?.commands?.updateSavedContent();
};

export const resetContent = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.setContent(editor.storage.originalState.savedContent.toJSON(), {
      emitUpdate: false,
   });
};

export const saveState = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.updateSavedContent();
};

export const clearSessionStorage = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.clearSessionStorage();
};

export const getCharacterCount = (editorid: string) => {
   const editor = getEditor(editorid);
   return editor?.storage?.characterCount?.characters();
};

export const clearError = (editorid: string) => {
   const editor = getEditor(editorid);
   editor?.commands?.clearError();
};

export const hasUnsavedChanges = (editorid: string) => {
   const editor = getEditor(editorid);
   return editor?.storage?.originalState?.hasUnsavedChanges;
};
